// 노드 기반 데이터 구조 정의

export type StepType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export interface NodeData {
  id: string;
  stepType: StepType;
  stepName: string;
  label: string;
  description?: string;
  data: any; // Step0Data | Step1Data 등
  isExpanded: boolean;
  isCompleted: boolean;
  requiredFields: string[]; // 필수 입력 항목
  completedFields: string[]; // 완료된 항목
}

export interface StepNode {
  id: string;
  type: 'stepNode';
  position: { x: number; y: number };
  data: NodeData;
}

export interface StepEdge {
  id: string;
  source: string;
  target: string;
  type?: 'smoothstep' | 'step' | 'straight';
  animated?: boolean;
}

export interface ProjectGraph {
  projectId: string;
  nodes: StepNode[];
  edges: StepEdge[];
}

// 단계별 기본 설정
export const STEP_CONFIG = {
  0: {
    name: '장르/소재 선택',
    color: '#10b981', // emerald
    requiredFields: ['mainGenre'],
  },
  1: {
    name: '세계관 설정',
    color: '#3b82f6', // blue
    requiredFields: ['worldSystem'],
  },
  2: {
    name: '캐릭터 설정',
    color: '#8b5cf6', // purple
    requiredFields: ['protagonists'],
  },
  3: {
    name: '캐릭터 상세',
    color: '#ec4899', // pink
    requiredFields: ['archetype'],
  },
  4: {
    name: '플롯 구조',
    color: '#f59e0b', // amber
    requiredFields: ['structure'],
  },
  5: {
    name: '에피소드 설계',
    color: '#14b8a6', // teal
    requiredFields: ['episodes'],
  },
  6: {
    name: '갈등 설계',
    color: '#ef4444', // red
    requiredFields: ['conflicts'],
  },
  7: {
    name: '세부 설정',
    color: '#6366f1', // indigo
    requiredFields: ['details'],
  },
  8: {
    name: '챕터 구성',
    color: '#a855f7', // violet
    requiredFields: ['chapters'],
  },
  9: {
    name: '타임라인',
    color: '#06b6d4', // cyan
    requiredFields: ['timeline'],
  },
  10: {
    name: '본문 집필',
    color: '#84cc16', // lime
    requiredFields: ['content'],
  },
} as const;

// 노드 간 X축 간격 (단계별)
export const STEP_X_SPACING = 400;
// 같은 단계 내 Y축 간격 (분기별)
export const NODE_Y_SPACING = 200;
// 시작 위치
export const START_X = 100;
export const START_Y = 100;
